const SortingActions = {
    SET_SORTING: 'SET_SORTING',
    SET_SORTING_OPTIONS: 'SET_SORTING_OPTIONS',
};

export { SortingActions };